module.exports = __webpack_public_path__ + "fc11b952748f0c0f275594fce6f72ffb.fbx";